import React from 'react';
import { LegacyKickstarterRedirect } from '~/components/common';

const VendorSourceMapRoot = () => (
  <LegacyKickstarterRedirect hash="/access-code-map" />
);

export default VendorSourceMapRoot;
